import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CameraIcon } from 'assets/icons/CameraIcon.svg';
import { ReactComponent as GalleryIcon } from 'assets/icons/Gallery.svg';

import { useStyles } from '../styles';

interface IProfilePictureMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onCapturePhoto: () => void;
  onUploadFromDevice: () => void;
  onSeeGallery: () => void;
}

const ProfilePictureMenu: React.FC<IProfilePictureMenuProps> = ({
  anchorEl,
  onClose,
  onCapturePhoto,
  onUploadFromDevice,
  onSeeGallery,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      className={classes.profilePicMenu}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <MenuItem
        className={classes.profilePicMenuItem}
        data-testid="profile-picture-capture-photo"
        onClick={onCapturePhoto}
      >
        {t('myProfile.profilePicture.menu.capturePhoto')}
      </MenuItem>
      <MenuItem
        className={classes.profilePicMenuItem}
        data-testid="profile-picture-upload-from-device"
        onClick={onUploadFromDevice}
      >
        {t('myProfile.profilePicture.menu.uploadFromDevice')}
      </MenuItem>
      <MenuItem className={classes.profilePicMenuItem} data-testid="profile-picture-see-gallery" onClick={onSeeGallery}>
        {t('myProfile.profilePicture.menu.seeGallery')}
      </MenuItem>
    </Menu>
  );
};

export default ProfilePictureMenu;
